import api from '../../helpers/api';
import { sortConversations, updatedConversationLastRead } from './DirectMessagesWidget-helpers';
import { IConversation, IDirectMessageState } from './DirectMessagesWidget-types';
import { store } from '../../main';

const directMessagesState: IDirectMessageState = {
    state: {
        activeConversation: null,
        conversations: [],
        expanded: false,
    },
    mutations: {
        addConversation(state, conversation: IConversation) {
            state.conversations.unshift(conversation);
        },
        updateConversation(state, updatedConversation: IConversation) {
            state.conversations = state.conversations.map((conversation) => {
                if (conversation.id === updatedConversation.id) {
                    return updatedConversation;
                }

                return conversation;
            }).sort(sortConversations);
        },
        setConversations(state, conversations: IConversation[]) {
            state.conversations = conversations.sort(sortConversations);
        },
        setActiveConversation(state, conversation: IConversation) {
            state.activeConversation = conversation;
        },
        markConversationAsReadLocally(state, options) {
            const { conversationId, currentUserId } = options;
            state.conversations = state.conversations.map(conversation =>
                updatedConversationLastRead(conversation, conversationId, currentUserId),
            );
        },
        setExpandedDirectMessages(state, value: boolean) {
            state.expanded = value;
        },
    },
    actions: {
        async sendDirectMessage({}, { conversationId, message }: any) {
            const payload = {
                conversationId,
                message,
            };

            const response = await api.request(`/conversation/${conversationId}/message`, 'POST', payload);

            return response;
        },
        async getConversations({ commit }) {
            const isLoggedIn = store.state.loginState?.userId;

            if (!isLoggedIn) {
                return;
            }

            const response = await api.request('/conversation/all', 'GET');

            if (response.ok) {
                commit('setConversations', await response.json());
            }
        },
        async markConversationAsRead({}, conversationId) {
            await api.request(`/conversation/${conversationId}/markAsRead`, 'POST');
        },
        markConversationAsReadLocally({ commit }, conversationId) {
            commit('markConversationAsReadLocally', conversationId);
        },
        setActiveConversation({ commit }, conversation) {
            commit('setActiveConversation', conversation);
        },
        addConversation({ commit }, newConversation) {
            commit('addConversation', newConversation);
        },
        updateConversation({ commit }, updatedConversation) {
            commit('updateConversation', updatedConversation);
        },
        setExpandedDirectMessages({ commit }, value) {
            commit('setExpandedDirectMessages', value);
        },
    },
};

export default directMessagesState;
